// Copyright (c) Docugami, Inc. All rights reserved.

import { Point } from "sdv/Types";
import { Component, ComponentId } from "sdv/engine/Component";

export interface ViewComponent extends Component {
    typeId: ComponentId.View;
    viewport: {
        width: number;
        height: number;
        worldWidth: number;
        worldHeight: number;
        worldPosition: Point;
    }
    view: {
        width: number;
        height: number;
    }
    world: {
        width: number;
        height: number;
    }
    worldToViewScale: number;
    viewToWorldScale: number;
}

export const defaultViewComponent = (): ViewComponent => ({
    typeId: ComponentId.View,
    viewport: {
        width: 0,
        height: 0,
        worldWidth: 0,
        worldHeight: 0,
        worldPosition: {
            x: 0,
            y: 0
        }
    },
    view: {
        width: 0,
        height: 0
    },
    world: {
        width: 0,
        height: 0
    },
    worldToViewScale: 0,
    viewToWorldScale: 0
})
